import Vue from 'vue'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import VueSocketio from 'vue-socket.io'

import App from './App.vue'
import { routes } from './routes'
import store from './Banet/store/store'
import vueClipboard2 from 'vue-clipboard2'

// import Acl from 'BanetAcl'
import BanetAcl from './Banet/plugins/BanetAcl.js'

import ElementUI from 'element-ui'
import enLocale from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'

import config from '../config';

Vue.use(ElementUI);
locale.use(enLocale);

Vue.use(VueRouter);
Vue.use(VueResource);
Vue.use(vueClipboard2);

// default parameters:
// const serverURL = 'http://alarmbot.banet.at'
const serverURL = (process.env.NODE_ENV && process.env.NODE_ENV === 'production') ? '' : config.url_main; //'http://localhost:3000';
console.log('serverURL: ', serverURL);
const roles = ['god4all', 'admin', 'user', 'client', 'client-admin', 'any'];
const defaultRole = 'any';
const aclRedirect = {
  'none': '/login',
  'any': '/login',
  'god4all': '/clients',
  'admin': '/clients',
  'user': '/',
  'client': '/',
  'client-admin': '/'
};
/**
 * mainEventBus
 * usage:
 * import { mainEventBus } from '../../../main';
 * mainEventBus.$emit( 'alert', { type:'warning', msg:'warning_lbl_all_required' } );
 * get data: mainEventBus.data.serverURL
  */
export const mainEventBus = new Vue({
  data: {
      serverURL: serverURL
  }
});

// import SocketIOFileUpload from 'socketio-file-upload/client.min.js';
// var uploadSocket = new SocketIOFileUpload(io('http://localhost:3000'));
// Vue.use( uploadSocket);

global.router = new VueRouter({
  mode: 'history',
  routes
});

Vue.use(BanetAcl, { router: router, d_permission: defaultRole, store: store, aclRedirect: aclRedirect, roles: roles });
//Vue.use(VueSocketio, io(mainEventBus.serverURL, {}, store));

// Vue.http.options.root = 'http://192.168.0.196:3000';
Vue.http.options.root = mainEventBus.serverURL;

Vue.http.interceptors.push((request, next) => {
  const token = store.getters.getToken;
  if (token) {
    request.headers.set('Authorization', 'Bearer ' + token)
  }

  next(res => {
    if (res.status == 422) {
      res.body.errors.forEach(err => {
        console.error('ERR from MAIN', err)
      })
    }
      /* if(res.status == 400 || res.status == 401) {
         store.dispatch('setErrors', res.body.errors || [res.body.error]);
         store.dispatch('logOut');
         router.go('/login');
      } */
  })
})

store.dispatch('logIn')

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js